module.exports = __webpack_public_path__ + "static/media/location-grey.61465227.svg";